import * as THREE from 'three';

import Assets from "./assets";
import Card from "./card";
import DNA from "./dna";

import { angleToVector } from "./utils";

const TAU = (Math.PI * 2.);
const slice = TAU / 7;

const MAX_RAIL_Y = 7

const diapositive_nice_indexes = [
    0, 1, 2, 3, 4, 5, 6,
    6, 4, 3, 2, 1, 0, 5,
    5, 2, 4, 6, 0, 1, 3
]

export default class Circles {
    components = {};
    animation = new gsap.timeline();
    dummyPosition = new THREE.Vector3();
    rail = new THREE.Group();
    rotor = new THREE.Group();
    dna = new DNA({
        scene: this.rail,
        attributes: {
            MAX_RAIL_Y
        }
    });
    
    PARAMS = {
        unfolded: 0,
        x: -5.000,
        y: 4.130,
        z: 6.957,
        rx: -1.911,
        ry: -0.410,
    }

    constructor({ scene, el }) {
        this.scene = scene;
        this.el = el;
        this.dna.elements = this.el.querySelectorAll(".wp-block-omnicom-call-to-action");

        this.dna.initialize();

        this.scene.add(this.rail);
        this.rail.add(this.rotor);
        this.rotor.position.y = 0;

        this.setComponents();
        this.initialize();

        Assets.manager.onStart = () => {
            // console.log("onStart");
        }
        Assets.manager.onProgress = (url, loaded, total) => {
            // console.log("Assets:onProgress", url, loaded, total);
        }

        Assets.manager.onLoad = () => {
            this.rotor.children.forEach((group, groupIndex) => {
                for(let i = 0; i < 7; i++) {
                    const card = group.children[i].children[0].children[0];

                    const imageIndex = diapositive_nice_indexes[groupIndex * 7 + i]

                    card.material.uniforms.map.value = Assets[`diapositives${imageIndex}`]
                    card.material.uniforms.ratio.value = Assets[`diapositives${imageIndex}`].width / Assets[`diapositives${imageIndex}`].height
                }
            })
            
            this.applyChanges();
            // this.setDebug()
        }
        Assets.init();
    }
    
    setComponents() {
        this.rotor.add(this.createCircle(3.3));
        this.rotor.add(this.createCircle(5.5));
        this.rotor.add(this.createCircle(7.7));
    }
    
    initialize() {
        this.setAnimation();
    }
    
    createCircle() {
        const group = new THREE.Group();
        group.position.z = -5;
        const cards = [];
                   
        for(let i = 0; i < 7; i++) {
            const card = new Card({ scene: group });
            cards.push(card);
        }
        return group;
    }

    applyRotorPosition({
        group,
        scalar,
        unfolded,
        offset
    }) {
        const { dummyPosition } = this;

        group.rotation.z = THREE.MathUtils.lerp(-Math.PI - ( offset * Math.PI * 0.314), Math.PI * 0.5 + slice * 3 + slice * 0.5 * offset % 2, unfolded);

        group.children.forEach((card, index) => {
            const rotation = slice * index * unfolded + slice * offset * unfolded;
            const pos = angleToVector(rotation);
            dummyPosition.x = pos.x
            dummyPosition.y = pos.y
            dummyPosition.z = 0;

            dummyPosition.multiplyScalar(scalar);
            
            card.children[0].position.copy(dummyPosition);
            card.children[0].rotation.x = Math.PI * 0.25 * (1.0 - unfolded);
            card.children[0].rotation.y = Math.PI * 0.25 * (1.0 - unfolded);
            card.children[0].rotation.z = rotation - Math.PI * 0.5;
        })
    }

    setAnimation() {
        const { animation, PARAMS } = this

        const lerp = {
            x: 0.25,
            y: 0,
            r: 0,
            cardsLeave: 0
        }
        const circling = new gsap.timeline();
        circling
            .to(lerp, {
                y: -(-MAX_RAIL_Y),
                ease: "linear",
                duration: 2,
                onUpdate: () => {
                    this.rotor.position.y = lerp.y
                }
            }, 'dna')
            .add(this.dna.enter(), 'dna')



            this.rotor.children.forEach(group => {
                for(let i = 0; i < 7; i++) {
                    const card = group.children[i];

                    circling.to(card.position, {
                        duration: 2,
                        physicsProps: {
                            x: { velocity: -3 * (Math.random()) , acceleration: -6 * (Math.random() * 0.5 + 0.5) },
                        }
                    }, 'dna')
                    circling.to(card.children[0].children[0].rotation, {
                        duration: 2,
                        y: -1,
                        physicsProps: {
                            y: { velocity: 24 * (Math.random() - 0.5) , acceleration: 12 },
                        }
                    }, 'dna')
                    
                }
            })

        animation
            .addLabel("intro")
            .to(lerp, {
                x: 1,
                ease: "linear",
                duration: 5,
                delay: 0.75,
                onUpdate: () => {
                    PARAMS.unfolded = lerp.x;
                    this.applyChanges();
                }
            }, 'aa')
            .add(circling)
            // .addLabel("circles")
            // .to(lerp, {
            //     x: 1,
            //     ease: "linear",
            //     duration: 1,
            // })
            .addLabel('slide0')

        const $texts = this.el.querySelectorAll(".wp-block-omnicom-call-to-action");
        gsap.set($texts, { autoAlpha: 0, yPercent: 100 })

        if ($texts) {
            for(let index = 0; index <  $texts.length - 1; index++) {
                animation
                    .add(this.dna.slide(index + 4), `slide${index + 1}`)
            }
        }
        


            const $textDuration = 0.5
            if ($texts) {
                for(let index = 0; index <  $texts.length - 1; index++) {
                    animation
                        .fromTo(
                            $texts[index],
                            {
                                autoAlpha: 0,
                                yPercent: 100
                            },
                            {
                                autoAlpha: 1,
                                ease: "linear",
                                duration: $textDuration,
                                yPercent: 0,
                                immediateRender: true
                            },
                            `slide${index + 1}-=${$textDuration}`)
                        .fromTo($texts[index],
                            {
                                autoAlpha: 1,
                                yPercent: 0
                            },
                            {
                                autoAlpha: 0,
                                ease: "linear",
                                duration: $textDuration,
                                yPercent: -100,
                                immediateRender: false
                            },
                        `slide${index + 1}`)
                }

                if ($texts[$texts.length - 1] && $texts.length > 1) {
                    animation
                        .fromTo($texts[$texts.length - 1],
                        {
                            autoAlpha: 0,
                            yPercent: 100
                        },
                        {
                            autoAlpha: 1,
                            ease: "linear",
                            duration: $textDuration,
                            yPercent: 0,
                            immediateRender: true,
                        },
                        `slide${$texts.length - 1}+=${$textDuration}`)
                        .fromTo($texts[$texts.length - 1],
                        {
                            autoAlpha: 1,
                            yPercent: 0
                        },
                        {
                            autoAlpha: 0,
                            ease: "linear",
                            duration: $textDuration,
                            yPercent: -100,
                            immediateRender: false,
                        },
                        'flash-cards')

                } else {
                    animation
                        .fromTo($texts[$texts.length - 1],
                        {
                            autoAlpha: 0,
                            yPercent: 100
                        },
                        {
                            autoAlpha: 1,
                            ease: "linear",
                            duration: $textDuration,
                            yPercent: 0
                        },
                        `slide${$texts.length - 1}-=${$textDuration}`)
                        .fromTo($texts[$texts.length - 1],
                        {
                            autoAlpha: 1,
                            yPercent: 0
                        },
                        {
                            autoAlpha: 0,
                            ease: "linear",
                            duration: $textDuration,
                            yPercent: -100
                        },
                        'flash-cards')
                }
            }
        animation
            .add(this.dna.enterFlashCards(), 'flash-cards')
            // .addLabel('end')
    }

    applyChanges() {
        const { PARAMS } = this;
        this.applyRotorPosition({
            group: this.rotor.children[0],
            scalar: 3.3,
            unfolded: PARAMS.unfolded,
            offset: 0
        });
        this.applyRotorPosition({
            group: this.rotor.children[1],
            scalar: 5.5,
            unfolded: PARAMS.unfolded,
            offset: 1
        });
        this.applyRotorPosition({
            group: this.rotor.children[2],
            scalar: 7.7,
            unfolded: PARAMS.unfolded,
            offset: 2
        });

        this.rotor.position.x = PARAMS.x * (1 - PARAMS.unfolded)
        this.rotor.position.y = PARAMS.y * (1 - PARAMS.unfolded)
        this.rotor.position.z = PARAMS.z * (1 - PARAMS.unfolded)
        this.rotor.rotation.x = PARAMS.rx * (1 - PARAMS.unfolded)
        this.rotor.rotation.y = PARAMS.ry * (1 - PARAMS.unfolded)
    }

    setDebug(pane) {
    }

    dispose() {
        Object.keys(this.components).forEach(_ => {
            this.components[_].dispose();
            delete this.components[_];
        });
    }
}
